import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Sentry from '@sentry/angular';

import pkgJson from '../package.json';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

console.log(`Swipes Web App - Version: ${pkgJson.version} Environment: ${environment.name.toString()}`);

if (environment.sentryDsn) {
  Sentry.init({
    dsn: environment.sentryDsn,
    sendDefaultPii: true,
    environment: environment.name.toString(),
  });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
